import type { ApiDocument } from '../../../api/types';

export type DocumentPreviewType = 'pdf' | 'docx' | 'xlsx' | 'doc' | 'xls' | 'md';

export const PDF_MIME_TYPE = 'application/pdf';

const PREVIEW_TYPE_BY_MIME_TYPE: Record<string, DocumentPreviewType> = {
  [PDF_MIME_TYPE]: 'pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  'application/msword': 'doc',
  'application/vnd.ms-excel': 'xls',
  'text/markdown': 'md',
  'text/x-markdown': 'md',
};

const PREVIEW_TYPE_BY_EXTENSION: Record<string, DocumentPreviewType> = {
  pdf: 'pdf',
  docx: 'docx',
  xlsx: 'xlsx',
  doc: 'doc',
  xls: 'xls',
  md: 'md',
  markdown: 'md',
};

export function getDocumentExtension(document: ApiDocument) {
  const { fileName, mimeType } = document;

  return getFileExtension(fileName, mimeType);
}

export function getFileExtension(fileName: string, mimeType: string) {
  if (fileName && fileName.indexOf('.') !== -1) {
    return fileName.split('.').pop();
  } else {
    return mimeType.split('/').pop();
  }
}

export function getColorFromExtension(extension: string) {
  switch (extension) {
    case 'apk':
    case 'xls':
    case 'xlsx':
    case 'ods':
      return 'green';
    case 'zip':
    case 'rar':
    case '7z':
    case 'tar':
    case 'gz':
    case 'bz2':
    case 'liz':
    case 'lz4':
    case 'lz5':
    case 'xz':
    case 'zst':
    case 'wim':
    case 'ppt':
    case 'pptx':
    case 'odp':
      return 'orange';
    case 'pdf':
    case 'xps':
      return 'red';
    default:
      return 'default';
  }
}

export function getDocumentHasPreview(document: ApiDocument) {
  return Boolean(document.previewBlobUrl || document.thumbnail);
}

export function getDocumentPreviewType(document: ApiDocument): DocumentPreviewType | undefined {
  const extension = getDocumentExtension(document)?.toLowerCase();

  return PREVIEW_TYPE_BY_MIME_TYPE[document.mimeType] ?? (extension ? PREVIEW_TYPE_BY_EXTENSION[extension] : undefined);
}
